
import axios from 'axios';

const getStats = async (token, filter) => {

    let statsData;
    var data = {
      "token": token,
      "filter": filter,
    };

    console.log('getStats data sent to server: ' + JSON.stringify(data))
    
    const headers = { 
        'Content-Type': 'application/json'
    };

    // console.log(data);
    try {
        statsData = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/stats', data, { headers })
        
    }catch(err) {
        console.log('getStats: error received from Axios',err.message);
        throw new Error(err.message); 
    }
    console.log('getStats results', JSON.stringify(statsData))

    return statsData;
    
};

export default getStats